import { DataType } from '../helpers/interfaces/DataType'

/**
 * Constructor for DataTypeModel
 * @param {*} bodyRequest
 * @param {*} uriParams
 */
const DataTypeModel = (bodyRequest = {}, uriParams = {}): DataType => ({ bodyRequest, uriParams })

export default DataTypeModel
